/* Alpe fit model v2 (2026-09-24) - osnovno merjenje (visina/teza).
   Linearni model, umerjen na 30 ekspertnih priporocilih Alpe (LOO 23/30 tocno, 29/30 +-1 velikost).
   indeks = konst + fit + b_teza*(kg-70) + b_visina*(cm-175) + profil + zenska -> zaokrozeno na velikost.
   Izven zanesljivega obmocja (BMI ali velikost izven tabele) vrne outOfRange -> natancno merjenje.
   Podatki o telesu se ne posiljajo nikamor. */
(function(root){
  var MODEL={
    base:2.4218,weight:0.1969,height:-0.0795,female:0.8317,
    fit:{tight:-0.3718,regular:0,relaxed:0.5255},
    profile:{
      'jersey-flow':-1.086,
      'jersey-diagonala-minimalist':-0.6369,
      'bibs-v1':-0.4042,
      'bibs-3f':-0.4329,
      'outerwear-krvavec':1.1892,
      'bibs-krvavec':1.3789
    },
    bmi:[17,32]
  };
  function recommend(o){
    var height=o.height,weight=o.weight,fit=o.fit||'regular',profile=o.profile,chart=o.chart;
    if(!Number.isFinite(height)||!Number.isFinite(weight)||height<140||height>210||weight<35||weight>160||!chart||!chart.sizes||!chart.sizes.length)return null;
    if(!Object.prototype.hasOwnProperty.call(MODEL.profile,profile))return null;
    var custom=(o.calibration&&o.calibration[profile])||{};
    var female=o.gender==='F';
    var index=MODEL.base+MODEL.profile[profile]+MODEL.weight*(weight-70)+MODEL.height*(height-175)
      +(female?MODEL.female:0)+(MODEL.fit[fit]||0)+(Number(custom.offset)||0);
    var n=chart.sizes.length,bmi=weight/Math.pow(height/100,2);
    var outOfRange=index>n-0.5||index<-1.5||bmi<MODEL.bmi[0]||bmi>MODEL.bmi[1];
    var rounded=Math.max(0,Math.min(n-1,Math.round(index)));
    return {size:chart.sizes[rounded],outOfRange:outOfRange,index:Math.round(index*100)/100,model:'alpe-expert-v2'};
  }
  if(typeof module==='object'&&module.exports)module.exports={recommend:recommend,MODEL:MODEL};else root.AlpeFit={recommend:recommend};
})(typeof window==='object'?window:this);
